import { useSyncExternalStore } from "react";
import { getCookieConsentValue } from "react-cookie-consent";
import { CONSENT_COOKIE_NAME } from "@/utils/consent/constants";

const listeners = new Set();

const subscribe = (onChange) => {
	listeners.add(onChange);
	return () => listeners.delete(onChange);
};

const getSnapshot = () => getCookieConsentValue(CONSENT_COOKIE_NAME) === undefined;
const getServerSnapshot = () => true;

export const notifyConsentChanged = () => {
	for (const listener of listeners) listener();
};

export const CONSENT_BANNER_OFFSET = 180;

export const useConsentPending = () =>
	useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
